import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
type CtaButtonProps = {
  label: string;
  microcopy?: string;
  className?: string;
};
export function CtaButton({
  label,
  microcopy,
  className = ''
}: CtaButtonProps) {
  return <div className={`mx-auto w-full max-w-xl ${className}`} data-id="element-32" data-mp="ck9f3o7axsdd">
      <a href={CHECKOUT_URL} onClick={trackCheckout} className="flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[16px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(31,168,85,0.75)] transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 active:scale-[0.98] sm:text-xl" data-id="element-33" data-mp="cn5dteqz4l2v">
        <CircleCheckIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-34" data-mp="19bbc7jxayh8p" />
        <span data-id="element-35" data-mp="15arf2gcqbdmk">{label}</span>
      </a>
      {microcopy && <p className="mt-3 text-center text-[13px] leading-relaxed text-ink-soft sm:text-sm" data-id="element-36" data-mp="35xfo76wcd5aa">{microcopy}</p>}
    </div>;
}